import React, { useState } from "react";
import "./forgotpassword.scss";
import Header from "../landing/navbar/Header";
import Footerline from "../landing/footer/Footerline";
import { Link } from "react-router-dom";
import axios from "axios";
import { Api_Url } from "../../utils/ApiUrl";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Forgotpassword = () => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const validateEmail = (email) => {
    const regex = /^[\w-]+(?:\.[\w-]+)*@(?:[\w-]+\.)+[a-zA-Z]{2,7}$/;
    return regex.test(email);
  };
  const handleForgotPassword = async () => {
    setIsLoading(true);
    if (!validateEmail(email)) {
      setErrors({ email: "Please enter a valid email address" });
      setIsLoading(false);
      return;
    }
    try {
      const response = await axios.post(
        `${Api_Url}/auth/users/forget-password`,
        { email }
      );
      console.log(response.data); // Log the response data
      setIsLoading(false);
      history.push("/emailsent");
    } catch (error) {
      setErrors({
        email:
          error.response.data.statusCode == "404"
            ? "user does not Exist!"
            : error.response.data.message,
      });
      console.error("Error:", error);
      setIsLoading(false);
    }
  };
  return (
    <>
      <Header />
      <section className="forgotmain">
        <div className="forgotinner">
          <h5 className="forgothead">Forgot Password</h5>
          <p className="forgotpara">
            Kindly enter your registered email address.
          </p>
          <div className="material-textfield ">
            <label>Email Address</label>
            <input
              onChange={(e) => {
                setEmail(e.target.value);
                setErrors("");
              }}
              name="email"
              placeholder="Email Address"
              value={email}
              type="text"
            />
          </div>
          <p className="redpara">
            {errors.email && (
              <span className="text-danger">{errors.email}</span>
            )}
          </p>
          <button onClick={handleForgotPassword} className="greybtn w-100">
            Request Link
          </button>
        </div>
      </section>
      <Footerline />
    </>
  );
};

export default Forgotpassword;
